/**
 * **duelEditor の舞台を組む共通の手順**（Issue #637）。**`duelEditor/timeline/` の外**。
 *
 * - `duelSourceFor` … replay（イベント列・盤面）→ editor のソース。演出の型はテーマの演出から作る
 */
import { createOcgSource } from './ocgSource';
import { withStatChangeEvents } from './statChanges';
import { withStartEvent } from './duelStart';
import { withMaterialSummonEvents } from './materialSummon';
import { duelSpecs } from './duelEffects';
import { fxObjectsChannel } from './fxObjects';
import { fxSceneChannel } from './fxScene';
import { effectOfClip } from '../duelEditor/core/effect';
import { THEMES } from '../duelEditor/themes';

/**
 * replay → editor のソース（`sourceOptions()` に通して `editor.setSource`）。イベントが無ければ null。
 *
 * @param getTheme 今のテーマを返す関数（帯の型から演出を引くのは**そのとき**のテーマ）
 * @param effectContext `duelEffectContext()`（places / clears / scene に盤面と履歴を渡す）
 */
export function duelSourceFor({
  state, replay, head, players = [], getTheme, effectContext, confirmedUids = null,
}) {
  /*
   * **ステータスの変化を疑似イベントにする**（Issue #584）。core は MSG に出さないので、`board_steps` の
   * `stat_changes` をイベントの列に `stat_change` として差し込む
   */
  const withStat = withStatChangeEvents({
    events: state?.events ?? [],
    boardSteps: state?.board_steps ?? null,
  });
  const { boardSteps } = withStat;
  /*
   * **デュエルの開始を疑似イベントにする**（Issue #645）。core は MSG_START を出さないので、先頭に `start` を足す
   */
  /*
   * **素材を使う召喚をまとめた疑似イベント**（Issue #647）。素材の move を 1 行にまとめ、出るモンスターも載せる
   */
  const withMaterial = withMaterialSummonEvents({ events: withStat.events, cardInfo: state?.card_info ?? null });
  const events = withStartEvent({
    events: withMaterial,
    firstPlayer: head?.firstPlayer ?? 0,
    startLp: head?.startLp ?? 8000,
  });
  if (!events.length) return null;
  // 帯の型の id（状況 ＋ 役割）で引く
  const effectOf = (type) => effectOfClip(getTheme()?.effects ?? [], { type });
  return createOcgSource({
    events,
    ops: replay?.ops ?? [],
    startMs: head?.startVideoMs ?? 0,
    startLp: head?.startLp ?? 8000,
    firstPlayer: head?.firstPlayer ?? 0,
    boardSteps,
    players,
    confirmedUids,
    // **テーマの演出を型の仕様にする**（置けば出る・消せば出ない）
    specs: duelSpecs(THEMES),
    channels: [
      // **演出が置いたものの生存**（Issue #534）と**舞台の設定**（Issue #535）
      fxObjectsChannel({ effectOf, contextOf: effectContext }),
      fxSceneChannel({ effectOf, contextOf: effectContext }),
    ],
  });
}
